import {EmployeeWorkspace} from '@innowise-group/core';
import {endOfDay, isWithinInterval, startOfDay} from 'date-fns';

enum StatusPrecedence {
  Occupied,
  Reserved,
  Remote,
}
const BOOKED = 'Booked';
const COWORKING_BOOKED = 'Coworking Booked';

function isWorkspaceBooked(workspace: EmployeeWorkspace): boolean {
  return [BOOKED, COWORKING_BOOKED].includes(workspace.status);
}

function isWorkspaceBookedToday(workspace: EmployeeWorkspace): boolean {
  const today = new Date();

  if (!isWorkspaceBooked(workspace) || !workspace.startDay || !workspace.endDay) {
    return false;
  }

  const startDay = startOfDay(new Date(workspace.startDay));
  const endDay = endOfDay(new Date(workspace.endDay));

  return isWithinInterval(today, {start: startDay, end: endDay});
}

export default function sortEmployeeWorkspaces(workspaces: EmployeeWorkspace[]) {
  const todayBookedWorkspaces: EmployeeWorkspace[] = [];
  const otherWorkspaces: EmployeeWorkspace[] = [];

  workspaces.forEach((workspace) => {
    if (isWorkspaceBookedToday(workspace)) {
      todayBookedWorkspaces.push(workspace);
    }
    if (!isWorkspaceBooked(workspace)) {
      otherWorkspaces.push(workspace);
    }
  });

  const sortedTodayBookedWorkspaces = [...todayBookedWorkspaces].sort(
    (workspaceCurrent, workspaceNext) =>
      new Date(workspaceNext.startDay).getTime() - new Date(workspaceCurrent.startDay).getTime(),
  );

  const sortedOtherWorkspaces = [...otherWorkspaces].sort(
    (workspaceCurrent, workspaceNext) =>
      StatusPrecedence[workspaceCurrent.status] - StatusPrecedence[workspaceNext.status],
  );

  return [...sortedTodayBookedWorkspaces, ...sortedOtherWorkspaces];
}
